import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens }) => ({
  icon24: {
    height: 24,

    '& > div': {
      height: 24,
    },

    '& img': {
      height: 24,
      width: 'auto',
    },
  },

  icon56: {
    height: 56,

    '& > div': {
      height: 56,
    },

    '& img': {
      height: 56,
      width: 'auto',
    },
  },

  errorLogo: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: tokens.spacing['4'],
  },
}));
